import { useResponsive } from 'store'

export const useOrderListDividingStore = defineStore('orderListDividing', () => {
  const orderListDividingRef = ref<HTMLDivElement>()
  const responsive = useResponsive()

  const mainElHeight = ref<number | string>(682)

  onBeforeMount(() => {})

  /** 盘口的列表行数 */
  const itemCount = computed(() => {
    if (responsive.isMobile) {
      return 8
    }
    return 7
  })

  watch(
    () => responsive.isMobile,
    (newVal) => {
      if (newVal) {
        mainElHeight.value = 'auto'
      } else {
        mainElHeight.value = 682
      }
    },
    {
      immediate: true,
    },
  )

  /** 实时成交的列表行数 */
  const realTimeTransactionItemCount = computed(() => {
    return 6
  })

  return { mainElHeight, orderListDividingRef, itemCount, realTimeTransactionItemCount }
})
